export default "__VITE_ASSET__BND_iTqg__"